import styled from '@emotion/styled'

export const Container = styled.div({
  textAlign: 'center',
  // height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
  
})